// extracted by mini-css-extract-plugin
export default {"wellSelect":"wellSelect-mfFW6","trigger":"trigger-pAzat","popover":"popover-gBqTm","labwareSelect":"labwareSelect-_jij3"};